import { toast } from 'react-toastify';

import moment from 'moment';
import qs from 'querystring';
import { takeLatest, call, put, all } from 'redux-saga/effects';

import { t } from '~/helpers';
import api from '~/services/api';
import history from '~/services/history';

import {
  successInRequest,
  failedRequest,
  successRemove,
  successRequest,
} from './actions';

export function* requestOperacaoBloqueioVeiculoPreFaturas({ payload }) {
  try {
    const { params } = payload;
    const response = yield call(api.get, 'operacaobloqueioveiculoprefaturas', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });
    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* deleteOperacaoBloqueioVeiculoPreFaturas({ payload }) {
  try {
    const { fatu_codigo, params } = payload;

    yield call(api.delete, `operacaobloqueioveiculoprefaturas/${fatu_codigo}`);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoexclusao'));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* store({ payload }) {
  try {
    const { operacaobloqueioveiculoprefaturas, params } = payload;

    yield call(
      api.post,
      'operacaobloqueioveiculoprefaturas',
      operacaobloqueioveiculoprefaturas
    );
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoinclusao'));
    history.push('/veiculobloqueiofaturamento');
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* find({ payload }) {
  try {
    const { fatu_codigo } = payload;

    const { data } = yield call(
      api.get,
      `operacaobloqueioveiculoprefaturas/${fatu_codigo}`
    );

    const dataMod = {
      ...data,
      datahorainicialmovimentacao: moment(
        data.datahorainicialmovimentacao,
        'DD/MM/YYYY HH:mm:ss',
        true
      ).format('YYYY-MM-DDTHH:mm:ss'),
      datahorafinalmovimentacao: moment(
        data.datahorafinalmovimentacao,
        'DD/MM/YYYY HH:mm:ss',
        true
      ).format('YYYY-MM-DDTHH:mm:ss'),
    };

    yield put(successRequest(dataMod));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* update({ payload }) {
  try {
    const { operacaobloqueioveiculoprefaturas, params } = payload;

    yield call(
      api.put,
      'operacaobloqueioveiculoprefaturas',
      operacaobloqueioveiculoprefaturas
    );
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoalteracao'));
    history.push('/veiculobloqueiofaturamento');
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* applyedFilters({ payload }) {
  try {
    const { params } = payload;

    const response = yield call(api.get, 'operacaobloqueioveiculoprefaturas', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });

    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}
//operacaobloqueioveiculoprefaturas
//OPERACAO
export default all([
  takeLatest(
    '@operacaobloqueioveiculoprefaturas/BLOQUEIOVEICULOS_IN_REQUEST',
    requestOperacaoBloqueioVeiculoPreFaturas
  ),
  takeLatest(
    '@operacaobloqueioveiculoprefaturas/DELETE_BLOQUEIOVEICULOS',
    deleteOperacaoBloqueioVeiculoPreFaturas
  ),
  takeLatest(
    '@operacaobloqueioveiculoprefaturas/SUCCESS_REMOVE',
    requestOperacaoBloqueioVeiculoPreFaturas
  ),
  takeLatest(
    '@operacaobloqueioveiculoprefaturas/STORE_BLOQUEIOVEICULOS',
    store
  ),
  takeLatest('@operacaobloqueioveiculoprefaturas/FIND_BLOQUEIOVEICULOS', find),
  takeLatest(
    '@operacaobloqueioveiculoprefaturas/UPDATE_BLOQUEIOVEICULOS',
    update
  ),
  takeLatest(
    '@operacaobloqueioveiculoprefaturas/RECORD_FILTERING',
    applyedFilters
  ),
]);
